<template>
  <div>
    <!-- Header -->
    <div class="header bg-gradient-success py-7 py-lg-8 pt-lg-9">
      <div class="separator separator-bottom separator-skew zindex-100">
        <svg
          x="0"
          y="0"
          viewBox="0 0 2560 100"
          preserveAspectRatio="none"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
        >
          <polygon
            class="fill-default"
            points="2560 0 2560 100 0 100"
          ></polygon>
        </svg>
      </div>
    </div>
    <!-- Page content -->
    <b-container class="mt--8 pb-5">
      <!-- Table -->
      <b-row class="justify-content-center">
        <b-col lg="6" md="8">
          <b-card no-body class="bg-secondary border-0">
            <b-card-body class="px-lg-5 py-lg-5">
              <div class="text-center text-muted mb-4">
                <h2>{{ $t("message.register_account") }}</h2>
              </div>
              <validation-observer
                v-slot="{ handleSubmit }"
                ref="formValidator"
              >
                <b-form role="form" @submit.prevent="handleSubmit(onSubmit)">
                  <base-input
                    alternative
                    class="mb-3"
                    prepend-icon="ni ni-hat-3"
                    :placeholder="$t('message.username')"
                    name="username"
                    :rules="{ required: true }"
                    v-model="model.username"
                  >
                  </base-input>

                  <base-input
                    alternative
                    class="mb-3"
                    prepend-icon="ni ni-email-83"
                    :placeholder="$t('message.email')"
                    name="Email"
                    :rules="{ required: true, email: true }"
                    v-model="model.email"
                  >
                  </base-input>

                  <base-input
                    alternative
                    class="mb-3"
                    prepend-icon="ni ni-lock-circle-open"
                    :placeholder="$t('message.reg_password')"
                    type="password"
                    name="Password"
                    :rules="{ required: true, min: 6 }"
                    v-model="model.password"
                  >
                  </base-input>
                  <label v-if="accountcreateerror" style="color:red;"
                    >{{ $t("message.account_creation_error") }}</label
                  >
                  <div class="text-center">
                    <b-button type="submit" variant="primary" class="mt-4"
                      >{{ $t("message.send") }}</b-button
                    >
                  </div>
                </b-form>
              </validation-observer>
            </b-card-body>
          </b-card>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>
<script>
import Vue from "vue";
import VueCookies from "vue-cookies";
import qs from "qs";
import axios from "axios";
import VueAxios from "vue-axios";

Vue.use(VueCookies);
Vue.use(VueAxios, axios);
//Vue.$cookies.config("30d");

export default {
  name: "register",
  data() {
    return {
      model: {
        username: "",
        email: "",
        password: ""
      },
      accountcreateerror: false
    };
  },
  methods: {
    onSubmit() {
      Vue.axios
        .post(
          "/app/create_account",
          qs.stringify({
            username: this.model.username,
            email: this.model.email,
            loginpassword: this.model.password
          })
        )
        .then(({ data }) => {
          if (data.status == 1) {
            this.accountcreateerror = false;
            //this.$modal.hide("login-modal");
            //this.$emit("loginevent");
            console.log("Login Yay!");
            this.$router.push({ name: "login" });
          } else {
            //show error
            this.accountcreateerror = true;
            console.log("login issue");
          }
        });
    }
  }
};
</script>
<style scoped>
.bg-gradient-success {
  background: linear-gradient(87deg, #e9ecef, #5da0e3) !important;
}
</style>
